// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Favorite48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Favorite48: FC<Favorite48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M35.642 9.88a7.524 7.524 0 0 0-5.124-.06h-.001c-1.796.624-3.07 2.289-3.925 4.065a15.454 15.454 0 0 0-1.11 3.186l-.007.042-.002.004a1.5 1.5 0 0 1-2.947 0v-.005a4.695 4.695 0 0 0-.01-.042c-.008-.04-.02-.102-.04-.185a15.447 15.447 0 0 0-1.066-3c-.855-1.775-2.128-3.44-3.926-4.064a7.522 7.522 0 0 0-5.126.06c-1.078.403-2.275 1.097-3.203 2.284-.911 1.167-1.651 2.922-1.655 5.615v.013c0 .019.004.057.009.113.01.111.032.295.079.54.094.49.29 1.231.691 2.15.8 1.83 2.442 4.411 5.835 7.134a61.396 61.396 0 0 1 8.3 8.052c.629.74 1.153 1.398 1.574 1.946.39-.511.872-1.12 1.451-1.805 1.817-2.148 4.59-5.066 8.44-8.188v-.001c3.382-2.741 5.027-5.325 5.832-7.154.404-.918.602-1.658.698-2.147a5.675 5.675 0 0 0 .091-.648v-.01c-.005-2.69-.743-4.442-1.654-5.608-.928-1.187-2.126-1.882-3.204-2.288ZM42 17.801l1.5.017v.017l-.001.028-.003.078a8.653 8.653 0 0 1-.144 1.072c-.135.69-.397 1.642-.896 2.776-1.002 2.275-2.945 5.24-6.687 8.275-3.688 2.99-6.328 5.773-8.038 7.796a39.553 39.553 0 0 0-1.882 2.394 22.42 22.42 0 0 0-.572.831l-.004.007-1.247 2.005-1.285-1.982c0-.002-.002-.004-.005-.008l-.026-.04a27.534 27.534 0 0 0-.604-.853 45.448 45.448 0 0 0-1.978-2.49 58.378 58.378 0 0 0-7.89-7.655c-3.763-3.02-5.709-5.988-6.708-8.272a13.241 13.241 0 0 1-.888-2.787 8.595 8.595 0 0 1-.138-1.078 3.62 3.62 0 0 1-.003-.078l-.001-.027v-.018c0-.001 0-.002 1.5-.008l-1.5.006v-.006c0-3.294.918-5.726 2.291-7.483 1.359-1.74 3.077-2.709 4.513-3.247a10.523 10.523 0 0 1 7.164-.085l.271.1c2.662 1.035 4.298 3.347 5.261 5.272.995-1.989 2.711-4.391 5.531-5.371v-.001a10.524 10.524 0 0 1 7.165.085h.001c1.435.54 3.153 1.509 4.512 3.248 1.373 1.757 2.291 4.188 2.291 7.482v.015l-1.5-.015Z" />
        </svg>
    );
};

export default Favorite48;
